export default "__VITE_PUBLIC_ASSET__003c1f81__"